import { Link } from "react-router-dom";

import {
  addTranslationData,
  useTranslation,
} from "@mywheels/common/lib/translation";
import { Car } from "@mywheels/common/lib/cars/types";
// import { useToggle } from "@mywheels/common/util";

import { useRoutes } from "web/lib/i18n";
import { SocialYoutubeIcon } from "web/ui/icons/social";
import { WebHandleidingCar } from "./queries";
// import { YouTubeVideoModal } from "web/components/YouTubeVideoModal";

addTranslationData({
  en: {
    "Alle handleidingen": "All car manuals",
  },
});

export function ManualPageHeader({
  car,
  graphcmsCar,
}: {
  car: Car;
  graphcmsCar?: WebHandleidingCar;
}) {
  const routes = useRoutes();
  const { t } = useTranslation();
  // const [showYouTubeModal, toggleYouTubeModal] = useToggle();

  return (
    <>
      {/* {!!graphcmsCar?.youtubeId && showYouTubeModal && (
        <YouTubeVideoModal
          id={graphcmsCar.youtubeId}
          onDismiss={toggleYouTubeModal}
        />
      )} */}

      <div className="mt-3 md:mt-10 mb-2 md:mb-4">
        <div className="mx-4 mb-6 text-center">
          <Link
            to={routes.CarManuals.url()}
            className="font-display text-gray underline md:text-lg"
          >
            <img
              className="inline-block mr-2 h-[20px] w-[78px] md:h-[30px] md:w-[117px]"
              alt=""
              // eslint-disable-next-line @typescript-eslint/no-var-requires
              src={require("./carmodels.jpg").default}
            />
            {t("Alle handleidingen")}
          </Link>
        </div>

        <h1 className="text-center md:text-4xl lg:text-5xl">
          <Link to={routes.CarManual.url({ carId: car.id })}>
            <span className="hidden md:inline text-lg md:text-4xl lg:text-5xl">
              {t("Handleiding")}{" "}
            </span>
            {car.brand} {car.model}
          </Link>
        </h1>
        {!!graphcmsCar?.youtubeId && (
          <div className="mt-2 px-4 text-center">
            <a
              className="text-blue font-display underline"
              // onClick={toggleYouTubeModal}
              target="_blank"
              rel="noreferrer"
              href={`https://www.youtube.com/watch?v=${graphcmsCar.youtubeId}`}
            >
              <SocialYoutubeIcon className="select-none mr-2" />
              {t("Bekijk de instructievideo")}
            </a>
          </div>
        )}
      </div>
    </>
  );
}
